import { render, staticRenderFns } from "./ViewItemOverlay.vue?vue&type=template&id=75bfcf6e&scoped=true"
import script from "./ViewItemOverlay.vue?vue&type=script&lang=js"
export * from "./ViewItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ViewItemOverlay.vue?vue&type=style&index=0&id=75bfcf6e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bfcf6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bfcf6e')) {
      api.createRecord('75bfcf6e', component.options)
    } else {
      api.reload('75bfcf6e', component.options)
    }
    module.hot.accept("./ViewItemOverlay.vue?vue&type=template&id=75bfcf6e&scoped=true", function () {
      api.rerender('75bfcf6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/browser/item-overlays/ViewItemOverlay.vue"
export default component.exports